// Remove SKU from collection items
function removeSKUFromTitles() {
  document.querySelectorAll('.boost-sd__product-title').forEach(el => {
    const currentText = el.textContent;
    const cleanText = currentText.replace(/\s?\(.*?\)/g, '');
    // Only update if the text actually changed (has SKU)
    if (currentText !== cleanText) {
      el.textContent = cleanText;
    }
  });
}

// Run on initial load
setTimeout(removeSKUFromTitles, 1000);

/**
 * Whether a Boost product card looks "on sale" (labels, sale classes, or compare > current).
 * Matches how applyVIPPricingToBoostProducts detects sale items.
 */
function isBoostProductOnSale(priceEl, productItem) {
  const saleLabel = productItem?.querySelector('.boost-sd__product-label--sale');
  const hasSalePriceClass = priceEl.classList.contains('boost-sd__product-price--sale');
  const hasSalePriceElement = productItem?.querySelector('.boost-sd__product-price--sale');

  const originalText = priceEl.textContent.trim();
  const cleanedText = originalText.replace(/Regular price/gi, '').replace(/\$\$/g, '$').trim();
  const priceMatch = cleanedText.match(/[\d,]+\.?\d*/);
  const currentPrice = priceMatch ? parseFloat(priceMatch[0].replace(/,/g, '')) : 0;

  const comparePriceEl =
    productItem?.querySelector('.boost-sd__product-price--compare') ||
    productItem?.querySelector('[data-compare-price]') ||
    priceEl.querySelector('.product-thumb__compare-price');

  let comparePrice = null;
  let comparePriceFromData = null;

  try {
    const productDataAttr = productItem?.getAttribute('data-product');
    if (productDataAttr) {
      const productData = JSON.parse(productDataAttr);
      const variant = productData.variants?.[0];
      if (variant && variant.compare_at_price !== null && variant.compare_at_price !== undefined) {
        comparePriceFromData = variant.compare_at_price / 100;
      }
    }
  } catch (e) {
    // Silent fail
  }

  if (comparePriceEl) {
    const compareText = comparePriceEl.textContent.trim();
    const compareMatch = compareText.match(/[\d,]+\.?\d*/);
    if (compareMatch) {
      comparePrice = parseFloat(compareMatch[0].replace(/,/g, ''));
    }
  }

  const finalComparePrice = comparePriceFromData !== null ? comparePriceFromData : comparePrice;
  const priceComparisonShowsSale =
    finalComparePrice !== null && finalComparePrice > currentPrice && currentPrice > 0;

  return !!(saleLabel || hasSalePriceClass || hasSalePriceElement || priceComparisonShowsSale);
}

// Hide sale pricing for Club Zone vendors (Adidas Club Zone, Nike Club Zone)
function hideClubZoneSalePricing() {
  // Check if we're on a Club Zone page by looking at body classes
  const bodyClasses = document.body.className.split(' ');
  let isClubZonePage = false;
  
  bodyClasses.forEach(className => {
    if (className.startsWith('zyber-')) {
      const zoneType = className.replace('zyber-', '');
      if (zoneType === 'adidas-club-zone' || zoneType === 'nike-club-zone') {
        isClubZonePage = true;
      }
    }
  });
  
  // Get customer VIP level for badge creation
  const customer = window.Rivo?.common?.customer;
  const tags = customer?.tags || [];
  let vipLevel = null;
  
  if (tags.includes('Rivo VIP Tier: Platinum')) {
    vipLevel = 'platinum';
  } else if (tags.includes('Rivo VIP Tier: Gold')) {
    vipLevel = 'gold';
  } else if (tags.includes('Rivo VIP Tier: Silver')) {
    vipLevel = 'silver';
  }
  
  const productPrices = document.querySelectorAll('.boost-sd__product-price');
  
  productPrices.forEach((priceEl) => {
    const productItem = priceEl.closest('.boost-sd__product-item');
    
    // Check if this specific product is a Club Zone vendor (for collection/search pages)
    let isClubZoneProduct = false;
    if (!isClubZonePage) {
      // Check vendor from boost-sd__product-vendor element
      const vendorEl = productItem?.querySelector('.boost-sd__product-vendor');
      const vendor = vendorEl ? vendorEl.textContent.trim() : '';
      if (vendor.toLowerCase().includes('club zone')) {
        isClubZoneProduct = true;
      }
    }
    
    // Skip if not on Club Zone page and not a Club Zone product
    if (!isClubZonePage && !isClubZoneProduct) {
      return;
    }
    
    // Check if VIP pricing was applied (has vip-original-price class)
    const hasVIPPricing = priceEl.querySelector('.vip-original-price') || 
                          priceEl.querySelector('.vip-discounted-price') ||
                          productItem?.querySelector('.boost-vip-badge');
    
    // Skip if already processed AND no VIP pricing was applied
    if (priceEl.dataset.clubZoneProcessed === 'true' && !hasVIPPricing) {
      return;
    }
    
    // Process all products on Club Zone pages
    try {
          const itemOnSale = isBoostProductOnSale(priceEl, productItem);

          // Hide sale labels
          const saleLabel = productItem?.querySelector('.boost-sd__product-label--sale');
          if (saleLabel) saleLabel.style.display = 'none';
          
          // Check if this is an Adidas Club Zone product - hide VIP badges for Adidas Club Zone
          const vendorEl = productItem?.querySelector('.boost-sd__product-vendor');
          const vendor = vendorEl ? vendorEl.textContent.trim() : '';
          // Check vendor name and tags for adidas-club-zone (case-insensitive, handle whitespace)
          const vendorNormalized = vendor.toLowerCase().trim();
          let isAdidasClubZone = vendorNormalized === 'adidas club zone' || vendorNormalized === 'adidas-club-zone' || vendorNormalized.includes('adidas') && vendorNormalized.includes('club');
          // Also check for adidas-club-zone tag
          if (!isAdidasClubZone) {
            try {
              const productDataAttr = productItem?.getAttribute('data-product');
              if (productDataAttr) {
                const productData = JSON.parse(productDataAttr);
                const tags = (productData.tags || []).map(t => t.toLowerCase());
                if (tags.includes('adidas-club-zone')) {
                  isAdidasClubZone = true;
                }
              }
            } catch (e) {
              // If parsing fails, continue with vendor check only
            }
          }
          
          // Check if product has limited-edition tag
          let hasLimitedEditionTag = false;
          try {
            const productDataAttr = productItem?.getAttribute('data-product');
            if (productDataAttr) {
              const productData = JSON.parse(productDataAttr);
              const tags = (productData.tags || []).map(t => t.toLowerCase());
              if (tags.includes('limited-edition')) {
                hasLimitedEditionTag = true;
              }
            }
          } catch (e) {
            // If parsing fails, continue
          }
          
          // Create or ensure VIP badges are visible if user has VIP tier (not Adidas Club Zone, not limited-edition, not on sale)
          let vipBadge = productItem?.querySelector('.boost-vip-badge');
          if (!isAdidasClubZone && !hasLimitedEditionTag && !itemOnSale) {
            if (vipLevel && productItem) {
              if (!vipBadge) {
                // Create badge if it doesn't exist
                vipBadge = document.createElement('div');
                vipBadge.className = 'boost-vip-badge';
                vipBadge.innerHTML = `<span class="vip-badge vip-badge--${vipLevel}">${vipLevel.charAt(0).toUpperCase() + vipLevel.slice(1)} Member</span>`;
                priceEl.parentNode.insertBefore(vipBadge, priceEl);
              } else {
                // Ensure existing badge is visible
                vipBadge.style.display = 'block';
                vipBadge.style.visibility = 'visible';
              }
            } else if (vipBadge) {
              // User doesn't have VIP tier but badge exists - keep it visible anyway
              vipBadge.style.display = 'block';
              vipBadge.style.visibility = 'visible';
            }
          } else if (vipBadge) {
            // Hide VIP badge for Adidas Club Zone, limited-edition, or sale items
            vipBadge.style.display = 'none';
            vipBadge.style.visibility = 'hidden';
          }
          
          // Find compare price element to extract original price before hiding
          // Check for strikethrough prices (could be from sale or VIP pricing)
          const comparePriceEl = productItem?.querySelector('.boost-sd__product-price--compare') || 
                                 productItem?.querySelector('[data-compare-price]') ||
                                 priceEl.querySelector('.product-thumb__compare-price') ||
                                 priceEl.querySelector('s.vip-original-price') ||
                                 priceEl.querySelector('s');
          
          let originalPrice = null;
          let currencySymbol = '$';
          
          // Extract original price from compare price or strikethrough element
          if (comparePriceEl) {
            const compareText = comparePriceEl.textContent.trim();
            const compareMatch = compareText.match(/[\d,]+\.?\d*/);
            if (compareMatch) {
              originalPrice = parseFloat(compareMatch[0].replace(/,/g, ''));
              currencySymbol = compareText.match(/\$/) ? '$' : '$';
            }
            // Hide the compare price element
            comparePriceEl.style.display = 'none';
          }
          
          // If we found an original price from strikethrough/compare, use it
          if (originalPrice && originalPrice > 0) {
            priceEl.innerHTML = `<span class="money">${currencySymbol}${originalPrice.toFixed(2)}</span>`;
          } else {
          // Check if there's a data attribute with original price
          const productDataAttr = productItem?.getAttribute('data-product');
          let variantPrice = null;
          if (productDataAttr) {
            try {
              const productData = JSON.parse(productDataAttr);
              variantPrice = productData.variants?.[0]?.price;
            } catch (e) {
              // Silent fail
            }
          }
          
          if (variantPrice) {
            // Use the variant price from product data (this is the original price)
            originalPrice = variantPrice / 100; // Shopify prices are in cents
            priceEl.innerHTML = `<span class="money">${currencySymbol}${originalPrice.toFixed(2)}</span>`;
          } else {
              // Extract current displayed price as fallback
              const originalText = priceEl.textContent.trim();
              const cleanedText = originalText.replace(/Regular price/gi, '').replace(/\$\$/g, '$').trim();
              // Remove any strikethrough text first
              const textWithoutStrike = cleanedText.replace(/<s>.*?<\/s>/gi, '').trim();
              const priceMatch = textWithoutStrike.match(/[\d,]+\.?\d*/);
              if (priceMatch) {
                const currentPrice = parseFloat(priceMatch[0].replace(/,/g, ''));
                // Only update if we have a valid price
                if (currentPrice > 0) {
                  priceEl.innerHTML = `<span class="money">${currencySymbol}${currentPrice.toFixed(2)}</span>`;
                }
              }
            }
          }
          
          // Remove sale price class and VIP classes from price element only
          priceEl.classList.remove('boost-sd__product-price--sale');
          priceEl.querySelectorAll('.vip-discounted-price, .vip-original-price').forEach(el => el.remove());
          
          // After price update: keep VIP badges hidden for sale items
          const vipBadgeAfter = productItem?.querySelector('.boost-vip-badge');
          if (vipBadgeAfter) {
            if (itemOnSale) {
              vipBadgeAfter.style.display = 'none';
              vipBadgeAfter.style.visibility = 'hidden';
            } else {
              vipBadgeAfter.style.display = 'block';
              vipBadgeAfter.style.visibility = 'visible';
            }
          }
          
          // Mark as processed
          priceEl.dataset.clubZoneProcessed = 'true';
          priceEl.dataset.vipProcessed = 'true'; // Also mark as VIP processed to prevent re-processing
    } catch (e) {
      // If parsing fails, continue with normal flow
      // Silent fail
    }
  });
}

// Apply VIP pricing to Boost app products
function applyVIPPricingToBoostProducts() {
  const customer = window.Rivo?.common?.customer;
  const tags = customer?.tags || [];
  let discountRate, vipLevel;
  
  if (tags.includes('Rivo VIP Tier: Platinum')) {
    discountRate = 0.93;
    vipLevel = 'platinum';
  } else if (tags.includes('Rivo VIP Tier: Gold')) {
    discountRate = 0.95;
    vipLevel = 'gold';
  } else if (tags.includes('Rivo VIP Tier: Silver')) {
    discountRate = 0.98;
    vipLevel = 'silver';
  } else {
    // Member tier or no tier - no VIP treatment
    discountRate = 1.0;
    vipLevel = null;
  }
  
  const productPrices = document.querySelectorAll('.boost-sd__product-price');
  
  productPrices.forEach((priceEl) => {
    // Skip if already processed
    if (priceEl.dataset.vipProcessed === 'true' && vipLevel) {
      return;
    }
    
    const productItem = priceEl.closest('.boost-sd__product-item');
    
    // Check if this is a gift card product - skip VIP pricing for gift cards
    const productLink = productItem?.querySelector('a[href*="/products/"]');
    const productUrl = productLink?.getAttribute('href') || '';
    const isGiftCard = productUrl.includes('/products/gift-card') || 
                       productItem?.querySelector('[data-gift-card]') ||
                       productItem?.classList.contains('gift-card-product');
    
    if (isGiftCard) {
      priceEl.dataset.vipProcessed = 'true';
      return; // Skip VIP pricing for gift cards
    }
    
    // Check if this product has the bookings tag or limited-edition tag - skip VIP pricing for these products
    // Declare once at the top of the loop to avoid redeclaration errors
    let hasBookingsTag = false;
    let hasLimitedEditionTagCheck = false;
    try {
      const productDataAttr = productItem?.getAttribute('data-product');
      if (productDataAttr) {
        const productData = JSON.parse(productDataAttr);
        const tags = (productData.tags || []).map(t => t.toLowerCase());
        if (tags.includes('bookings')) {
          hasBookingsTag = true;
        }
        if (tags.includes('limited-edition')) {
          hasLimitedEditionTagCheck = true;
        }
      }
    } catch (e) {
      // If parsing fails, continue with normal flow
    }
    
    if (hasBookingsTag) {
      priceEl.dataset.vipProcessed = 'true';
      return; // Skip VIP pricing for products with bookings tag
    }
    
    if (hasLimitedEditionTagCheck) {
      priceEl.dataset.vipProcessed = 'true';
      return; // Skip VIP pricing for products with limited-edition tag
    }
    
    // Check if we're on a Club Zone page OR if this product is a Club Zone vendor
    try {
      const bodyClasses = document.body.className.split(' ');
      let isClubZonePage = false;
      
      bodyClasses.forEach(className => {
        if (className.startsWith('zyber-')) {
          const zoneType = className.replace('zyber-', '');
          if (zoneType === 'adidas-club-zone' || zoneType === 'nike-club-zone') {
            isClubZonePage = true;
          }
        }
      });
      
      // Also check if this specific product is a Club Zone vendor
      let isClubZoneProduct = false;
      const vendorEl = productItem?.querySelector('.boost-sd__product-vendor');
      const vendor = vendorEl ? vendorEl.textContent.trim() : '';
      if (vendor.toLowerCase().includes('club zone')) {
        isClubZoneProduct = true;
      }
      
      // Check if this is specifically Adidas Club Zone - hide badges for Adidas Club Zone
      // Check vendor name and tags for adidas-club-zone (case-insensitive, handle whitespace)
      const vendorNormalized = vendor.toLowerCase().trim();
      let isAdidasClubZone = vendorNormalized === 'adidas club zone' || vendorNormalized === 'adidas-club-zone' || vendorNormalized.includes('adidas') && vendorNormalized.includes('club');
      // Also check for adidas-club-zone tag
      if (!isAdidasClubZone) {
        try {
          const productDataAttr = productItem?.getAttribute('data-product');
          if (productDataAttr) {
            const productData = JSON.parse(productDataAttr);
            const tags = (productData.tags || []).map(t => t.toLowerCase());
            if (tags.includes('adidas-club-zone')) {
              isAdidasClubZone = true;
            }
          }
        } catch (e) {
          // If parsing fails, continue with vendor check only
        }
      }
      
      if (isClubZonePage || isClubZoneProduct) {
        // Check if product has limited-edition tag (reuse variable declared at top of loop)
        try {
          const productDataAttr = productItem?.getAttribute('data-product');
          if (productDataAttr) {
            const productData = JSON.parse(productDataAttr);
            const tags = (productData.tags || []).map(t => t.toLowerCase());
            if (tags.includes('limited-edition')) {
              hasLimitedEditionTagCheck = true;
            }
          }
        } catch (e) {
          // If parsing fails, continue
        }
        
        const onSaleForBadge = isBoostProductOnSale(priceEl, productItem);

        // On Club Zone pages/products, create badges but skip pricing modification
        // However, do NOT create badges for Adidas Club Zone products, limited-edition, or sale items
        if (vipLevel && productItem && !isAdidasClubZone && !hasLimitedEditionTagCheck && !onSaleForBadge) {
          let vipBadge = productItem.querySelector('.boost-vip-badge');
          if (!vipBadge) {
            vipBadge = document.createElement('div');
            vipBadge.className = 'boost-vip-badge';
            vipBadge.innerHTML = `<span class="vip-badge vip-badge--${vipLevel}">${vipLevel.charAt(0).toUpperCase() + vipLevel.slice(1)} Member</span>`;
            priceEl.parentNode.insertBefore(vipBadge, priceEl);
          }
        } else if (isAdidasClubZone || hasLimitedEditionTagCheck || onSaleForBadge) {
          // Hide any existing VIP badges
          const existingBadge = productItem.querySelector('.boost-vip-badge');
          if (existingBadge) {
            existingBadge.style.display = 'none';
            existingBadge.style.visibility = 'hidden';
          }
        }
        priceEl.dataset.clubZoneProcessed = 'true';
        return;
      }
    } catch (e) {
      // If parsing fails, continue with normal flow
      // Silent fail
    }
    
    // Skip Club Zone vendors (handled by hideClubZoneSalePricing)
    if (priceEl.dataset.clubZoneProcessed === 'true') {
      return;
    }
    const originalText = priceEl.textContent.trim();
    const cleanedText = originalText.replace(/Regular price/gi, '').replace(/\$\$/g, '$').trim();
    const priceMatch = cleanedText.match(/[\d,]+\.?\d*/);

    const currentPrice = priceMatch ? parseFloat(priceMatch[0].replace(/,/g, '')) : 0;
    const isOnSale = isBoostProductOnSale(priceEl, productItem);

    // Only apply VIP pricing if user has VIP tier
    if (!vipLevel) {
      return;
    }

    if (isOnSale) {
      const existingBadge = productItem?.querySelector('.boost-vip-badge');
      if (existingBadge) {
        existingBadge.style.display = 'none';
        existingBadge.style.visibility = 'hidden';
      }
      priceEl.dataset.vipProcessed = 'true';
      return;
    }

    // Skip VIP pricing if product has limited-edition tag
    if (hasLimitedEditionTagCheck) {
      priceEl.dataset.vipProcessed = 'true';
      return; // Skip VIP pricing for products with limited-edition tag
    }
    
    if (priceMatch && currentPrice > 0) {
      const currencySymbol = originalText.match(/\$/) ? '$' : '$';
      const originalPrice = currentPrice;
      const discountedPrice = currentPrice * discountRate;
      
      priceEl.innerHTML = `
        <span class="money vip-discounted-price">${currencySymbol}${discountedPrice.toFixed(2)}</span>
        <s class="product-thumb__compare-price vip-original-price">${currencySymbol}${originalPrice.toFixed(2)}</s>
      `;
      
      if (productItem) {
        const existingBadge = productItem.querySelector('.boost-vip-badge');
        if (existingBadge) existingBadge.remove();
        
        const vipBadge = document.createElement('div');
        vipBadge.className = 'boost-vip-badge';
        vipBadge.innerHTML = `<span class="vip-badge vip-badge--${vipLevel}">${vipLevel.charAt(0).toUpperCase() + vipLevel.slice(1)} Member</span>`;
        
        priceEl.parentNode.insertBefore(vipBadge, priceEl);
      }
      
      priceEl.dataset.vipProcessed = 'true';
    }
  });
}

// Apply VIP pricing and Club Zone pricing when page loads
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    hideClubZoneSalePricing(); // Run first to prevent VIP pricing
    applyVIPPricingToBoostProducts();
    hideClubZoneSalePricing(); // Run again after to clean up any VIP pricing that was applied
  }, 1000);
});

// Also run after a delay to catch late-loading products
setTimeout(() => {
  hideClubZoneSalePricing(); // Run first to prevent VIP pricing
  applyVIPPricingToBoostProducts();
  hideClubZoneSalePricing(); // Run again after to clean up any VIP pricing that was applied
}, 2000);

// Apply VIP pricing and remove SKUs when Boost app updates the product list
const observer = new MutationObserver(mutations => {
  let shouldUpdate = false;
  
  mutations.forEach(mutation => {
    // Check for added product items
    if (mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('boost-sd__product-item') || 
              node.querySelector?.('.boost-sd__product-item') ||
              node.classList?.contains('boost-sd__product-list') ||
              node.querySelector?.('.boost-sd__product-title')) {
            shouldUpdate = true;
          }
        }
      });
    }
    
    // Also check for changes to existing elements (pagination might update content)
    if (mutation.type === 'childList' && mutation.target.classList?.contains('boost-sd__product-list')) {
      shouldUpdate = true;
    }
  });
  
  if (shouldUpdate) {
    setTimeout(() => {
      hideClubZoneSalePricing(); // Run first to prevent VIP pricing
      applyVIPPricingToBoostProducts();
      hideClubZoneSalePricing(); // Run again after to clean up any VIP pricing that was applied
      removeSKUFromTitles();
    }, 100);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also listen for Boost-specific events
document.addEventListener('boost-sd:filter-results-updated', () => {
  setTimeout(() => {
    hideClubZoneSalePricing(); // Run first to prevent VIP pricing
    applyVIPPricingToBoostProducts();
    hideClubZoneSalePricing(); // Run again after to clean up any VIP pricing that was applied
    removeSKUFromTitles();
  }, 100);
});

// Watch for pagination clicks
document.addEventListener('click', (e) => {
  if (e.target.closest('.boost-sd__pagination-item') || 
      e.target.closest('[data-boost-pagination]')) {
    setTimeout(() => {
      hideClubZoneSalePricing(); // Run first to prevent VIP pricing
      applyVIPPricingToBoostProducts();
      hideClubZoneSalePricing(); // Run again after to clean up any VIP pricing that was applied
      removeSKUFromTitles();
    }, 500);
  }
});

// Club Zone Join Modal
document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('club-zone-join-modal');
  const triggers = document.querySelectorAll('[data-club-zone-modal-trigger]');
  const closeButtons = document.querySelectorAll('[data-club-zone-modal-close]');
  const optionButtons = document.querySelectorAll('.club-zone-modal__option');
  const optionsBody = document.querySelector('[data-modal-body="options"]');
  const formBody = document.querySelector('[data-modal-body="form"]');
  const modalTitle = document.querySelector('[data-modal-title]');
  const joinForm = document.getElementById('club-zone-join-form');
  
  if (!modal || triggers.length === 0) return;
  
  // Populate club select option values if they're empty (from Liquid loop)
  const clubSelect = document.getElementById('club-select');
  if (clubSelect) {
    populateClubSelectValuesFallback('club-select');
  }
  
  // Function to show options view
  function showOptionsView() {
    if (optionsBody) optionsBody.style.display = 'block';
    if (formBody) formBody.style.display = 'none';
    if (modalTitle) modalTitle.textContent = 'Ultra Football Club Store';
  }
  
  // Function to show form view
  function showFormView() {
    if (optionsBody) optionsBody.style.display = 'none';
    if (formBody) formBody.style.display = 'block';
    if (modalTitle) modalTitle.textContent = 'Join an Existing Club';
  }
  
  // Open modal - show form directly
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      showFormView(); // Show form directly instead of options
      
      // Move modal to body if it's not already there to break out of parent constraints
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      
      // Set display and ensure high z-index
      modal.style.display = 'flex';
      modal.style.zIndex = '99999';
      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.right = '0';
      modal.style.bottom = '0';
      modal.style.width = '100vw';
      modal.style.height = '100vh';
      document.body.style.overflow = 'hidden';
    });
  });
  
  // Close modal
  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      if (formBody) formBody.style.display = 'block'; // Keep form view for next open
    });
  });
  
  // Handle option selection
  optionButtons.forEach(button => {
    button.addEventListener('click', function() {
      const option = this.dataset.option;
      
      if (option === 'join-existing') {
        // Show the form view
        showFormView();
      } else if (option === 'register-interest') {
        // Scroll to contact form or show interest form
        modal.style.display = 'none';
        document.body.style.overflow = '';
        const contactForm = document.querySelector('[id*="qikify"]');
        if (contactForm) {
          contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
  
  // Handle form submission
  if (joinForm) {
    joinForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      
      // Get submit button and store original text
      const submitButton = joinForm.querySelector('button[type="submit"], .club-zone-modal__submit-btn, input[type="submit"]');
      const originalButtonText = submitButton ? (submitButton.textContent || submitButton.value) : '';
      
      // Get club metaobject handle from select (label is club name; API needs handle)
      const clubSelect = joinForm.querySelector('#club-select');
      const clubValue = clubSelect
        ? getSelectedClubMetaobjectHandle(clubSelect)
        : (formData.get('club') || '').toString().trim();
      
      // Get customer ID from Rivo or Shopify customer object
      const customerId = window.Rivo?.common?.customer?.id || 
                        (window.Shopify?.customer?.id ? window.Shopify.customer.id.toString() : null);
      
      if (!customerId) {
        alert('Error: Customer ID not found. Please log in and try again.');
        return;
      }
      
      if (!clubValue || clubValue === '') {
        alert('Please select a club');
        clubSelect?.focus();
        return;
      }
      
      // Update button text and disable it
      if (submitButton) {
        if (submitButton.tagName === 'INPUT') {
          submitButton.value = 'Please wait...';
        } else {
          submitButton.textContent = 'Please wait...';
        }
        submitButton.disabled = true;
      }
      
      try {
        // Make PATCH request to Gadget endpoint
        const response = await fetch(`/apps/gadget/customers/${customerId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            club: clubValue
          })
        });
        
        const responseText = await response.text();
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}, body: ${responseText}`);
        }
        
        // Try to parse JSON only if there's content
        let result = null;
        if (responseText && responseText.trim() !== '') {
          try {
            result = JSON.parse(responseText);
          } catch (e) {
            result = { success: true, message: responseText };
          }
        } else {
          result = { success: true };
        }
        
        // Hide the form and show success message
        if (formBody) formBody.style.display = 'none';
        
        // Create or show success message
        let successMessage = document.querySelector('.club-zone-modal__success');
        if (!successMessage) {
          successMessage = document.createElement('div');
          successMessage.className = 'club-zone-modal__success';
          successMessage.innerHTML = '<p class="club-zone-modal__success-text">Thanks for joining the club store!</p>';
          const modalBody = document.querySelector('.club-zone-modal__body');
          if (modalBody) {
            modalBody.appendChild(successMessage);
          }
        }
        successMessage.style.display = 'block';
        
        // If API call succeeded, the club was assigned - redirect to your-club page
        // Add a delay to allow backend processing and page refresh
        setTimeout(function() {
          window.location.href = '/pages/your-club';
        }, 1500);
        
      } catch (error) {
        alert('Error joining club. Please try again.');
        
        // Restore button text and enable it on error
        if (submitButton) {
          if (submitButton.tagName === 'INPUT') {
            submitButton.value = originalButtonText;
          } else {
            submitButton.textContent = originalButtonText;
          }
          submitButton.disabled = false;
        }
      }
    });
  }
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      if (formBody && formBody.style.display === 'block') {
        // If form is showing, go back to options
        showOptionsView();
      } else {
        // If options are showing, close modal
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  });
});

// Club Store Enquiry Modal
document.addEventListener('DOMContentLoaded', function() {
  const enquiryModal = document.getElementById('club-store-enquiry-modal');
  const enquiryTrigger = document.querySelector('[data-club-enquiry-modal-trigger]');
  const enquiryCloseButtons = document.querySelectorAll('[data-club-enquiry-modal-close]');
  const enquiryForm = document.getElementById('club-store-enquiry-form');
  
  if (!enquiryModal || !enquiryTrigger) return;
  
  // Open modal
  enquiryTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Move modal to body if it's not already there to break out of parent constraints
    if (enquiryModal.parentElement !== document.body) {
      document.body.appendChild(enquiryModal);
    }
    
    // Set display and ensure high z-index
    enquiryModal.style.display = 'flex';
    enquiryModal.style.zIndex = '99999';
    enquiryModal.style.position = 'fixed';
    enquiryModal.style.top = '0';
    enquiryModal.style.left = '0';
    enquiryModal.style.right = '0';
    enquiryModal.style.bottom = '0';
    enquiryModal.style.width = '100vw';
    enquiryModal.style.height = '100vh';
    document.body.style.overflow = 'hidden';
  });
  
  // Close modal
  enquiryCloseButtons.forEach(button => {
    button.addEventListener('click', function() {
      enquiryModal.style.display = 'none';
      document.body.style.overflow = '';
    });
  });
  
  // Handle form submission
  if (enquiryForm) {
    enquiryForm.addEventListener('submit', function(e) {
      e.preventDefault();
      // TODO: Handle form submission - backend API call required
      const formData = new FormData(this);
      
      // For now, redirect to Shopify registration
      const club = formData.get('club');
      const firstName = formData.get('first_name');
      const lastName = formData.get('last_name');
      const email = formData.get('email');
      const password = formData.get('password');
      const subscribe = formData.get('subscribe');
      
      // Build registration URL with parameters
      const returnUrl = encodeURIComponent(window.location.pathname);
      const registerUrl = `/account/register?return_url=${returnUrl}`;
      
      // Note: Shopify's registration form will need to be customized to accept club selection
      // This is a placeholder - actual implementation requires backend integration
      window.location.href = registerUrl;
    });
  }
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && enquiryModal.style.display === 'flex') {
      enquiryModal.style.display = 'none';
      document.body.style.overflow = '';
    }
  });
});

// Hide empty product image wrappers on your-club page
document.addEventListener('DOMContentLoaded', function() {
  const productImageWrappers = document.querySelectorAll('.club-zone-product-image-wrapper');
  
  productImageWrappers.forEach((wrapper) => {
    const img = wrapper.querySelector('.club-zone-product-image');
    
    if (img && (!img.src || img.src === '' || img.src === window.location.href)) {
      wrapper.style.display = 'none';
    }
  });
});

// Redirect logged-in users with club tags from club-zone-new to your-club
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the club-zone-new page
  if (window.location.pathname.includes('club-zone-new')) {
    const customer = window.Rivo?.common?.customer;
    const tags = customer?.tags || [];
    let hasClub = false;
    
    tags.forEach(tag => {
      if (tag.includes('club:')) {
        hasClub = true;
      }
    });
    
    // If logged in and has club tag, redirect to your-club
    if (customer && hasClub) {
      window.location.href = '/pages/your-club';
      return;
    }
  }
});

// Club Zone Login Redirect System
// Set flag when any login action is triggered from club-zone-new or your-club page
document.addEventListener('DOMContentLoaded', function() {
  var onClubPage = window.location.pathname.includes('club-zone-new') || window.location.pathname.includes('your-club');

  if (onClubPage) {
    document.querySelectorAll('.login-btn').forEach(function(button) {
      button.addEventListener('click', function() {
        localStorage.setItem('clubZoneLoginRedirect', 'true');
      });
    });

    // Catch links that go to the login page (but not /account, which is the "my account" page)
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (link) {
        var href = link.getAttribute('href') || '';
        if (href.includes('/account/login')) {
          localStorage.setItem('clubZoneLoginRedirect', 'true');
        }
      }
    });
  }
  
  // Clear flag if user navigates away from login page (changes their mind)
  if (window.location.pathname.includes('/account/login')) {
    // Clear flag if user clicks any link that navigates away (except form submission)
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      if (link) {
        const href = link.getAttribute('href');
        // If clicking a link that's not login/register related, clear the flag
        if (href && !href.includes('/account/login') && !href.includes('/account/register') && !href.startsWith('#')) {
          localStorage.removeItem('clubZoneLoginRedirect');
        }
      }
    });
    
    // Clear flag on browser back/forward navigation away from login
    window.addEventListener('popstate', function() {
      if (!window.location.pathname.includes('/account/login')) {
        localStorage.removeItem('clubZoneLoginRedirect');
      }
    });
  }
  
  // Clear flag if user navigates to any page other than login/account/club pages
  const currentPath = window.location.pathname;
  const isLoginPage = currentPath.includes('/account/login');
  const isAccountPage = currentPath === '/account' || currentPath === '/account/';
  const isClubRelatedPage = currentPath.includes('club-zone') || currentPath.includes('your-club');
  
  if (!isLoginPage && !isAccountPage && !isClubRelatedPage) {
    // User navigated to a different page - clear the flag
    localStorage.removeItem('clubZoneLoginRedirect');
  }
  
  // Note: Redirect logic is now handled in account.liquid template using Liquid
  // This provides immediate redirect without waiting for JavaScript customer data
});

// Update menu link for club-store based on customer club status
var _clubMenuRetries = 0;
function updateClubStoreMenuLink() {
  var customer = window.Rivo?.common?.customer;

  // If Rivo data hasn't loaded yet, retry up to 30 times (3 seconds)
  if (customer === undefined || customer === null) {
    _clubMenuRetries++;
    if (_clubMenuRetries < 30) {
      setTimeout(updateClubStoreMenuLink, 100);
    }
    return;
  }

  var tags = customer?.tags || [];
  var hasClub = false;
  tags.forEach(function(tag) {
    if (tag && typeof tag === 'string' && tag.includes('club:')) {
      hasClub = true;
    }
  });
  
  if (hasClub) {
    // Find all links to club-zone-new and update them to your-club
    const clubStoreLinks = document.querySelectorAll('a[href*="club-zone-new"], a[href*="/pages/club-zone-new"]');
    
    clubStoreLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && (href.includes('club-zone-new') || href.includes('/pages/club-zone-new'))) {
        link.href = '/pages/your-club';
        
        // Update text while preserving menu structure
        const navText = link.querySelector('.navtext');
        if (navText) {
          navText.textContent = 'Your Club';
        } else {
          // Fallback: update link text directly if no navtext element
          if (link.textContent.trim().toLowerCase().includes('club')) {
            link.textContent = 'Your Club';
          }
        }
      }
    });
    
    // Also check for links by text content
    const allLinks = document.querySelectorAll('a');
    allLinks.forEach(link => {
      const text = link.textContent.trim().toLowerCase();
      const href = link.getAttribute('href');
      if ((text.includes('club store') || text.includes('club-store')) && href && href.includes('club-zone-new')) {
        link.href = '/pages/your-club';
        
        // Update text while preserving menu structure
        const navText = link.querySelector('.navtext');
        if (navText) {
          navText.textContent = 'Your Club';
        } else {
          link.textContent = 'Your Club';
        }
      }
    });
  } else {
    // No club - revert "Your Club" links back to "Club Store"
    // Exclude login buttons and other specific classes
    const yourClubLinks = document.querySelectorAll('a[href*="your-club"]:not(.login-btn):not(.logout-btn):not(.create-account-btn), a[href*="/pages/your-club"]:not(.login-btn):not(.logout-btn):not(.create-account-btn)');
    
    yourClubLinks.forEach(link => {
      // Skip if it's a login/logout/account button
      if (link.classList.contains('login-btn') || link.classList.contains('logout-btn') || link.classList.contains('create-account-btn')) {
        return;
      }
      
      const href = link.getAttribute('href');
      if (href && (href.includes('your-club') || href.includes('/pages/your-club'))) {
        link.href = '/pages/club-zone-new';
        
        // Update text while preserving menu structure
        const navText = link.querySelector('.navtext');
        if (navText) {
          navText.textContent = 'Club Store';
        } else {
          // Fallback: update link text directly if no navtext element
          if (link.textContent.trim().toLowerCase().includes('your club')) {
            link.textContent = 'Club Store';
          }
        }
      }
    });
    
    // Also check for links by text content, but exclude login buttons
    const allLinks = document.querySelectorAll('a:not(.login-btn):not(.logout-btn):not(.create-account-btn)');
    allLinks.forEach(link => {
      // Skip if it's a login/logout/account button
      if (link.classList.contains('login-btn') || link.classList.contains('logout-btn') || link.classList.contains('create-account-btn')) {
        return;
      }
      
      const text = link.textContent.trim().toLowerCase();
      const href = link.getAttribute('href');
      if (text.includes('your club') && href && href.includes('your-club')) {
        link.href = '/pages/club-zone-new';
        
        // Update text while preserving menu structure
        const navText = link.querySelector('.navtext');
        if (navText) {
          navText.textContent = 'Club Store';
        } else {
          link.textContent = 'Club Store';
        }
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', updateClubStoreMenuLink);

/** Metaobject entry handle for Gadget PATCH (from data-club-handle or option value). */
function getSelectedClubMetaobjectHandle(selectEl) {
  if (!selectEl || selectEl.selectedIndex < 0) return '';
  const opt = selectEl.options[selectEl.selectedIndex];
  if (!opt || opt.disabled) return '';
  const fromData = opt.getAttribute('data-club-handle');
  if (fromData && fromData.trim() !== '') return fromData.trim();
  return (opt.value || '').trim();
}

// Function to populate empty option values from text (for Liquid-rendered options)
function populateClubSelectValuesFallback(selectElementId) {
  const clubSelect = document.getElementById(selectElementId);
  if (clubSelect) {
    Array.from(clubSelect.options).forEach(option => {
      const dataHandle = option.dataset.clubHandle && option.dataset.clubHandle.trim();
      if (dataHandle) {
        if (!option.value || option.value === '') {
          option.value = dataHandle;
        }
        return;
      }
      if (!option.value || option.value === '') {
        // Create a handle from the option text
        const handle = option.text.trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        option.value = handle;
      }
    });
  }
}

// Club Change/Leave Modal Functionality
document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('club-zone-change-modal');
  const switchClubLink = document.getElementById('switch-club-link');
  const closeButtons = document.querySelectorAll('[data-club-change-modal-close]');
  const modalTitle = document.querySelector('[data-club-modal-title]');
  const modalBody = document.querySelector('[data-club-modal-body]');
  const changeContent = document.querySelector('[data-club-modal-content="change"]');
  const changeForm = document.getElementById('club-zone-change-form');
  
  if (!modal) return;
  
  // Populate club select option values if they're empty (from Liquid loop)
  function populateClubSelectValues() {
    populateClubSelectValuesFallback('club-change-select');
  }
  
  // Populate values when modal opens
  populateClubSelectValues();
  
  // Show change club modal
  function showChangeClubModal() {
    if (modalTitle) modalTitle.textContent = 'CHANGE CLUBS';
    // Populate values when opening modal (from Liquid loop)
    populateClubSelectValues();
    
    // Move modal to body if it's not already there to break out of parent constraints
    // This fixes the issue where parent containers have height: 0
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    
    // Set display to flex - ensure it's visible
    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    // Ensure positioning - use viewport units to ensure full height
    modal.style.position = 'fixed';
    modal.style.top = '0';
    modal.style.left = '0';
    modal.style.right = '0';
    modal.style.bottom = '0';
    modal.style.width = '100vw';
    modal.style.height = '100vh';
    modal.style.margin = '0';
    modal.style.padding = '0';
    modal.style.zIndex = '9999';
    document.body.style.overflow = 'hidden';
  }
  
  // Close modal
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
  
  // Switch club link click
  if (switchClubLink) {
    switchClubLink.addEventListener('click', function(e) {
      e.preventDefault();
      showChangeClubModal();
    }, true); // Use capture phase to catch it early
  }
  
  // Close modal buttons
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      closeModal();
    });
  });
  
  // Handle change club form submission
  if (changeForm) {
    changeForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const clubSelect = document.getElementById('club-change-select');
      
      // Ensure values are populated before checking
      populateClubSelectValues();
      
      const clubValue = clubSelect ? clubSelect.value : '';
      
      if (!clubValue || clubValue === '') {
        alert('Please select a club');
        clubSelect?.focus();
        return;
      }
      
      // Get customer ID
      const customerId = window.Rivo?.common?.customer?.id;
      if (!customerId) {
        alert('Please log in to change your club');
        return;
      }
      
      const confirmButton = changeForm.querySelector('.club-zone-modal__confirm-btn');
      const originalButtonText = confirmButton ? confirmButton.textContent : 'CONFIRM';
      
      // Update button text and disable it
      if (confirmButton) {
        confirmButton.textContent = 'Loading...';
        confirmButton.disabled = true;
      }
      
      try {
        const response = await fetch(`/apps/gadget/customers/${customerId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            club: clubValue
          })
        });
        
        const responseText = await response.text();
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}, body: ${responseText}`);
        }
        
        // Try to parse JSON only if there's content
        let result = null;
        if (responseText && responseText.trim() !== '') {
          try {
            result = JSON.parse(responseText);
          } catch (e) {
            result = { success: true, message: responseText };
          }
        } else {
          result = { success: true };
        }
        
        // Success - redirect to refresh the page
        setTimeout(function() {
          window.location.href = '/pages/your-club';
        }, 500);
        
      } catch (error) {
        alert('Error changing club. Please try again.');
        
        // Restore button text and enable it on error
        if (confirmButton) {
          confirmButton.textContent = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });
  }
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });
});

  

// Enhanced override header breakpoint to force mobile menu at 1024px
(function() {
  const MOBILE_BREAKPOINT = 1024;
  
  function overrideHeaderBreakpoint() {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    
    // Force compress class based on our breakpoint
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      header.classList.add('site-header--compress');
    } else {
      header.classList.remove('site-header--compress');
    }
  }
  
  // Run after theme scripts with delays
  setTimeout(function() {
    overrideHeaderBreakpoint();
    
    // Override on resize with capture phase for higher priority
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(overrideHeaderBreakpoint, 50);
    }, true);
    
    // Override theme resize events
    document.addEventListener('theme:resize', function() {
      setTimeout(overrideHeaderBreakpoint, 10);
    }, true);
  }, 200);
  
  // Multiple delayed runs to ensure override
  setTimeout(overrideHeaderBreakpoint, 500);
  setTimeout(overrideHeaderBreakpoint, 1000);
})();
// Function to hide NEW badges when coming soon badges are present
function hideNewBadgesWhenComingSoonPresent() {
  document.querySelectorAll('.boost-sd__product-item').forEach(function(productItem) {
    const comingSoonBadge = productItem.querySelector('.coming-soon-flag');
    if (comingSoonBadge) {
      const newBadges = productItem.querySelectorAll('.new-item-flag');
      newBadges.forEach(badge => {
        badge.style.display = 'none';
      });
    }
  });
}

// Add Coming Soon badge to Boost products with "coming-soon" tag
function addComingSoonBadgesToBoost() {
  document.querySelectorAll('.boost-sd__product-item[data-product]').forEach(function(productItem) {
    // Skip if badge already added
    if (productItem.querySelector('.coming-soon-flag')) {
      return;
    }
    
    try {
      // Parse the data-product JSON
      const productDataAttr = productItem.getAttribute('data-product');
      if (!productDataAttr) return;
      
      const productData = JSON.parse(productDataAttr);
      
      // Handle casing for tags (coming-soon vs Coming-Soon)
      const tags = (productData.tags || []).map(t => t.toLowerCase());
      
      // Check if product has "coming-soon" tag
      if (tags.includes('coming-soon')) {
        // Find the image wrapper where badges should be placed
        const imageWrapper = productItem.querySelector('.boost-sd__product-image-wrapper');
        if (!imageWrapper) return;
        
        // Check if badge column exists in top row
        let badgeColumn = imageWrapper.querySelector('.boost-sd__product-image-column--in-top.boost-sd__product-image-column--left');
        
        if (!badgeColumn) {
          // Try to find or create the top row
          let topRow = imageWrapper.querySelector('.boost-sd__product-image-row--top');
          if (!topRow) {
            // Create top row if it doesn't exist
            topRow = document.createElement('div');
            topRow.className = 'boost-sd__product-image-row boost-sd__product-image-row--top';
            imageWrapper.insertBefore(topRow, imageWrapper.firstChild);
          }
          
          // Create the badge column
          badgeColumn = document.createElement('div');
          badgeColumn.className = 'boost-sd__product-image-column boost-sd__product-image-column--in-top boost-sd__product-image-column--left';
          topRow.appendChild(badgeColumn);
        }
        
        // Create and add the coming soon badge
        const badge = document.createElement('div');
        badge.className = 'coming-soon-flag';
        badge.textContent = 'COMING SOON';
        badgeColumn.appendChild(badge);
      }
    } catch (e) {
      console.error('Error parsing Boost product data for coming soon badge:', e);
    }
  });
}

// Apply Coming Soon badges when page loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(addComingSoonBadgesToBoost, 1000);
  });
} else {
  setTimeout(addComingSoonBadgesToBoost, 1000);
}

// Also run after a delay to catch late-loading products
setTimeout(addComingSoonBadgesToBoost, 2000);

// Watch for dynamically added products
const comingSoonObserver = new MutationObserver(function(mutations) {
  let shouldCheck = false;
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (
          node.classList?.contains('boost-sd__product-item') ||
          node.querySelector?.('.boost-sd__product-item')
        )) {
          shouldCheck = true;
        }
      });
    }
  });
  
  if (shouldCheck) {
    setTimeout(addComingSoonBadgesToBoost, 100);
  }
});

comingSoonObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Also listen for Boost-specific events
document.addEventListener('boost-sd:filter-results-updated', function() {
  setTimeout(addComingSoonBadgesToBoost, 200);
});
// Add or remove New Item badge on Boost products based on "new-item" tag
function addNewItemBadgesToBoost() {
  document.querySelectorAll('.boost-sd__product-item[data-product]').forEach(function(productItem) {
    try {
      // 1. Get Product Data
      const productDataAttr = productItem.getAttribute('data-product');
      if (!productDataAttr) return;
      
      const productData = JSON.parse(productDataAttr);
      const title = productData.title;
      
      // Handle casing (New-Item vs new-item)
      const tags = (productData.tags || []).map(t => t.toLowerCase());
      const hasNewItemTag = tags.includes('new-item');
      const hasComingSoonTag = tags.includes('coming-soon');

      // If product has coming soon tag, hide NEW badges and skip adding new ones
      if (hasComingSoonTag) {
        const existingBadges = productItem.querySelectorAll('.new-item-flag');
        if (existingBadges.length > 0) {
          existingBadges.forEach(badge => {
            badge.style.display = 'none';
          });
        }
        return;
      }

      // Hide NEW badge when sale pricing / sale badge is active
      const saleLabel = productItem.querySelector('.boost-sd__product-label--sale');
      const priceEl = productItem.querySelector('.boost-sd__product-price');
      const hasSalePriceClass = priceEl && priceEl.classList.contains('boost-sd__product-price--sale');
      const hasSalePriceElement = productItem.querySelector('.boost-sd__product-price--sale');
      const isOnSale = !!(saleLabel || hasSalePriceClass || hasSalePriceElement);
      
      // 2. Check for existing badge
      const existingBadges = productItem.querySelectorAll('.new-item-flag');
      
      if (hasNewItemTag && !isOnSale) {
        // --- CASE: Product HAS tag ---
        
        if (existingBadges.length > 0) {
           return;
        }
        
        // Find wrapper
        const imageWrapper = productItem.querySelector('.boost-sd__product-image-wrapper');
        if (!imageWrapper) {
          console.error(`❌ ${title} - Could not find .boost-sd__product-image-wrapper`);
          return;
        }
        
        // 1. Find or Create Top Row
        let topRow = imageWrapper.querySelector('.boost-sd__product-image-row--top');
        if (!topRow) {
          topRow = document.createElement('div');
          topRow.className = 'boost-sd__product-image-row boost-sd__product-image-row--top';
          imageWrapper.insertBefore(topRow, imageWrapper.firstChild);
        }
        
        // 2. Find or Create Right Column
        let badgeColumn = topRow.querySelector('.boost-sd__product-image-column--right');
        if (!badgeColumn) {
          badgeColumn = document.createElement('div');
          // Important: We ensure ALL classes are present so CSS works
          badgeColumn.className = 'boost-sd__product-image-column boost-sd__product-image-column--in-top boost-sd__product-image-column--right';
          topRow.appendChild(badgeColumn);
        }
        
        // 3. Add Badge
        const badge = document.createElement('div');
        badge.className = 'new-item-flag';
        badge.textContent = 'NEW';
        badgeColumn.appendChild(badge);
        
        // 4. Check if coming soon badge exists in DOM and hide NEW badge if it does
        const comingSoonBadge = productItem.querySelector('.coming-soon-flag');
        if (comingSoonBadge) {
          badge.style.display = 'none';
        }
        
      } else {
        // --- CASE: Product MISSING tag OR on sale (hide NEW when sale badge/pricing is active) ---
        if (existingBadges.length > 0) {
           existingBadges.forEach(badge => badge.remove());
        }
      }
    } catch (e) {
      console.error('Error parsing Boost product data:', e);
    }
  });
}

// Apply New Item badges when page loads
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(addNewItemBadgesToBoost, 1000);
});

// Also run after a delay to catch late-loading products
setTimeout(addNewItemBadgesToBoost, 2000);

// Watch for dynamically added products
const newItemObserver = new MutationObserver(function(mutations) {
  let shouldCheck = false;
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (
          node.classList?.contains('boost-sd__product-item') ||
          node.querySelector?.('.boost-sd__product-item')
        )) {
          shouldCheck = true;
        }
      });
    }
  });
  
  if (shouldCheck) {
    setTimeout(addNewItemBadgesToBoost, 100);
  }
});

newItemObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Also listen for Boost-specific events
document.addEventListener('boost-sd:filter-results-updated', function() {
  setTimeout(addNewItemBadgesToBoost, 200);
});

// Handle "Notify me when available" link clicks on product page
document.addEventListener('click', function(e) {
  const notifyLink = e.target.closest('.product__notify-link');
  if (!notifyLink) return;
  
  e.preventDefault();
  e.stopPropagation();
  
  // Get the notification popup HTML from the link
  const notificationPopupHtml = notifyLink.getAttribute('data-notification-popup');
  if (!notificationPopupHtml) return;
  
  // Create a temporary button element to trigger the notification popup
  // This mimics what happens when the sold out button is clicked
  const tempButton = document.createElement('button');
  tempButton.setAttribute('data-notification-popup', notificationPopupHtml);
  tempButton.setAttribute('data-add-to-cart', '');
  tempButton.style.display = 'none';
  tempButton.type = 'button'; // Prevent form submission
  
  // Add to form so CartDrawer can find it in context
  const form = notifyLink.closest('form');
  if (form) {
    form.appendChild(tempButton);
  } else {
    document.body.appendChild(tempButton);
  }
  
  // Trigger click - CartDrawer should handle it
  // Use setTimeout to ensure CartDrawer is ready
  setTimeout(function() {
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    tempButton.dispatchEvent(clickEvent);
    
    // Clean up after a short delay
    setTimeout(function() {
      if (tempButton.parentNode) {
        tempButton.parentNode.removeChild(tempButton);
      }
    }, 100);
  }, 50);
});

// Fix for ProductAccordion height issue - ensure expanded accordions show content
(function() {
  function getFullHeight(element) {
    if (!element) return 0;
    
    // Get computed styles for padding
    const styles = getComputedStyle(element);
    const paddingTop = parseFloat(styles.paddingTop) || 0;
    const paddingBottom = parseFloat(styles.paddingBottom) || 0;
    const marginTop = parseFloat(styles.marginTop) || 0;
    const marginBottom = parseFloat(styles.marginBottom) || 0;
    
    // Use scrollHeight for content, or offsetHeight if scrollHeight is unreliable
    const scrollHeight = element.scrollHeight;
    const offsetHeight = element.offsetHeight;
    
    // Use the larger value to ensure we get all content
    const contentHeight = Math.max(scrollHeight, offsetHeight);
    
    // Add padding and margins
    return contentHeight + paddingTop + paddingBottom + marginTop + marginBottom;
  }
  
  function fixToggleEllipsis(toggleEllipsis) {
    if (!toggleEllipsis) return;
    
    const maxHeight = 500; // Content limit before showing read more
    
    const content = toggleEllipsis.querySelector('[data-content]');
    const actions = toggleEllipsis.querySelector('[data-actions]');
    
    if (content) {
      // Get actual content height
      const contentHeight = content.scrollHeight || content.offsetHeight;
      const isOpen = toggleEllipsis.classList.contains('is-open');
      
      if (contentHeight > maxHeight) {
        // Content exceeds 500px - show read more, cap at 500px
        toggleEllipsis.classList.add('is-enabled');
        
        if (isOpen) {
          // Already expanded - show full content
          const actionsHeight = actions ? (actions.scrollHeight || actions.offsetHeight || 40) : 40;
          toggleEllipsis.style.setProperty('--height', (contentHeight + actionsHeight) + 'px', 'important');
        } else {
          // Collapsed - cap at 500px
          toggleEllipsis.style.setProperty('--height', maxHeight + 'px', 'important');
        }
      } else {
        // Content is under 500px - show full content, no read more
        toggleEllipsis.classList.remove('is-enabled');
        toggleEllipsis.style.setProperty('--height', contentHeight + 'px', 'important');
      }
    }
  }
  
  function fixAccordionHeight(container) {
    if (!container || !container.classList.contains('is-expanded')) return;
    
    const content = container.querySelector('[data-collapsible-content]');
    if (!content) return;
    
    // Fix toggle-ellipsis height first
    const toggleEllipsis = content.querySelector('toggle-ellipsis');
    if (toggleEllipsis) {
      fixToggleEllipsis(toggleEllipsis);
      // Wait a moment for toggle-ellipsis to update
      setTimeout(() => {
        // Recalculate after toggle-ellipsis is fixed
        const fullHeight = getFullHeight(content);
        const currentHeight = parseInt(container.style.height, 10) || 0;
        
        if (fullHeight > 50 && (currentHeight < 100 || currentHeight < fullHeight - 10)) {
          container.style.setProperty('height', fullHeight + 'px', 'important');
        }
      }, 50);
    }
    
    // Calculate full height including padding
    const fullHeight = getFullHeight(content);
    const currentHeight = parseInt(container.style.height, 10) || 0;
    
    // If height is too small or doesn't match content, fix it
    if (fullHeight > 50 && (currentHeight < 100 || currentHeight < fullHeight - 10)) {
      // Force the height using setProperty for better override
      container.style.setProperty('height', fullHeight + 'px', 'important');
      
      // Set to auto after transition completes for responsive behavior
      setTimeout(() => {
        if (container.classList.contains('is-expanded')) {
          container.style.setProperty('height', 'auto', 'important');
        }
      }, 600);
    }
  }
  
  function fixAccordionHeights() {
    const expandedContainers = document.querySelectorAll('[data-collapsible-container].is-expanded');
    expandedContainers.forEach(fixAccordionHeight);
    
    // Also fix all toggle-ellipsis elements in expanded accordions
    const toggleEllipsisElements = document.querySelectorAll('[data-collapsible-container].is-expanded toggle-ellipsis');
    toggleEllipsisElements.forEach(fixToggleEllipsis);
  }
  
  // Fix on page load with multiple attempts (waiting for content to render)
  function initFix() {
    // Wait a bit for content to render before measuring
    setTimeout(() => {
      fixAccordionHeights();
      setTimeout(fixAccordionHeights, 100);
      setTimeout(fixAccordionHeights, 300);
      setTimeout(fixAccordionHeights, 600);
      setTimeout(fixAccordionHeights, 1000);
    }, 50);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFix);
  } else {
    initFix();
  }
  
  // Watch for style attribute changes and fix immediately
  const styleObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const target = mutation.target;
        
        // Fix accordion containers
        if (target.hasAttribute('data-collapsible-container') && 
            target.classList.contains('is-expanded')) {
          const height = parseInt(target.style.height, 10) || 0;
          if (height > 0 && height < 100) {
            setTimeout(() => fixAccordionHeight(target), 10);
          }
        }
        
        // Fix toggle-ellipsis elements
        if (target.tagName === 'TOGGLE-ELLIPSIS') {
          setTimeout(() => fixToggleEllipsis(target), 10);
        }
      }
    });
  });
  
  // Observe all accordion containers and toggle-ellipsis elements
  document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('[data-collapsible-container]');
    containers.forEach(container => {
      styleObserver.observe(container, {
        attributes: true,
        attributeFilter: ['style']
      });
    });
    
    const toggleEllipsisElements = document.querySelectorAll('toggle-ellipsis');
    toggleEllipsisElements.forEach(el => {
      styleObserver.observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      // Fix immediately
      fixToggleEllipsis(el);
      
      // Listen for the theme's toggle event and fix heights after
      el.addEventListener('theme:ellipsis:toggle', function(event) {
        const isExpanded = event.detail.isExpanded;
        const toggleEllipsis = event.target;
        const content = toggleEllipsis.querySelector('[data-content]');
        const maxHeight = 500;
        
        if (content) {
          const contentHeight = content.scrollHeight || content.offsetHeight;
          
          function updateAccordionContainer() {
            const accordionContainer = toggleEllipsis.closest('[data-collapsible-container]');
            if (accordionContainer && accordionContainer.classList.contains('is-expanded')) {
              const accordionContent = accordionContainer.querySelector('[data-collapsible-content]');
              if (accordionContent) {
                const originalTransition = accordionContainer.style.transition;
                accordionContainer.style.transition = 'none';
                const accordionHeight = getFullHeight(accordionContent);
                accordionContainer.style.setProperty('height', accordionHeight + 'px', 'important');
                accordionContainer.style.setProperty('height', 'auto', 'important');
                setTimeout(() => { accordionContainer.style.transition = originalTransition; }, 10);
              }
            }
          }
          
          if (isExpanded) {
            // Expanding - show full content + read less at bottom
            // Use auto height so actions sit naturally at the bottom
            toggleEllipsis.style.setProperty('--height', 'auto', 'important');
            toggleEllipsis.style.setProperty('overflow', 'visible', 'important');
            setTimeout(updateAccordionContainer, 100);
          } else {
            // Collapsing - cap at 500px, show read more
            toggleEllipsis.style.setProperty('--height', maxHeight + 'px', 'important');
            toggleEllipsis.style.removeProperty('overflow');
            setTimeout(updateAccordionContainer, 550);
          }
        }
      });
    });
  });
  
  // Also fix when accordions are clicked
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-collapsible-trigger]');
    if (trigger) {
      const containerId = trigger.getAttribute('aria-controls');
      if (containerId) {
        const container = document.getElementById(containerId);
        if (container) {
          // Wait for content to expand before measuring
          setTimeout(() => {
            fixAccordionHeight(container);
            setTimeout(() => fixAccordionHeight(container), 100);
            setTimeout(() => fixAccordionHeight(container), 300);
            setTimeout(() => fixAccordionHeight(container), 600);
          }, 50);
        }
      }
    }
  });
})();

// Ensure automatic VIP discounts are applied before checkout
(function() {
  'use strict';
  
  const DEBUG = true; // Set to false to disable debug logs
  
  function debugLog(...args) {
    if (DEBUG) {
      console.log('[VIP Checkout Debug]', ...args);
    }
  }
  
  function debugError(...args) {
    console.error('[VIP Checkout Error]', ...args);
  }
  
  // Check if customer is VIP
  function isVIPCustomer() {
    const customer = window.Rivo?.common?.customer;
    const tags = customer?.tags || [];
    
    debugLog('Customer tags:', tags);
    
    const isVIP = tags.includes('Rivo VIP Tier: Platinum') || 
                  tags.includes('Rivo VIP Tier: Gold') || 
                  tags.includes('Rivo VIP Tier: Silver');
    
    debugLog('Is VIP customer:', isVIP);
    
    if (isVIP) {
      if (tags.includes('Rivo VIP Tier: Platinum')) {
        debugLog('VIP Tier: Platinum');
      } else if (tags.includes('Rivo VIP Tier: Gold')) {
        debugLog('VIP Tier: Gold');
      } else if (tags.includes('Rivo VIP Tier: Silver')) {
        debugLog('VIP Tier: Silver');
      }
    }
    
    return isVIP;
  }
  
  // Check if product should have VIP pricing disabled
  function isProductVIPEligible(productTags) {
    if (!productTags || !Array.isArray(productTags)) return true;
    const eligible = !productTags.includes('adidas-club-zone') && !productTags.includes('nike-club-zone');
    debugLog('Product tags:', productTags, 'Eligible:', eligible);
    return eligible;
  }
  
  // Check if cart has VIP-eligible items
  async function hasVIPEligibleItems() {
    try {
      debugLog('Checking cart for VIP-eligible items...');
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      debugLog('Cart items:', cart.items);
      
      if (!cart.items || cart.items.length === 0) {
        debugLog('No items in cart');
        return false;
      }
      
      // Check if any items are VIP eligible
      let eligibleCount = 0;
      for (const item of cart.items) {
        const productTags = item.product_tags || [];
        debugLog(`Item: ${item.product_title}, Tags:`, productTags);
        if (isProductVIPEligible(productTags)) {
          eligibleCount++;
        }
      }
      
      debugLog(`VIP-eligible items: ${eligibleCount} of ${cart.items.length}`);
      return eligibleCount > 0;
    } catch (error) {
      debugError('Error checking cart items:', error);
      return true; // Default to true to be safe
    }
  }
  
  // Refresh cart to trigger automatic discounts
  async function refreshCartForAutomaticDiscounts() {
    try {
      debugLog('Refreshing cart to trigger automatic discounts...');
      
      // Fetch current cart state
      const beforeResponse = await fetch('/cart.js');
      const beforeCart = await beforeResponse.json();
      
      debugLog('Cart before refresh:', {
        item_count: beforeCart.item_count,
        total_price: beforeCart.total_price,
        original_total_price: beforeCart.original_total_price,
        discount_applications: beforeCart.discount_applications,
        discount_codes: beforeCart.discount_codes
      });
      
      // If cart has items, trigger a cart update to ensure automatic discounts are applied
      if (beforeCart.items && beforeCart.items.length > 0) {
        // Update cart with a no-op change to trigger discount recalculation
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {} // Empty updates just refreshes the cart
          })
        });
        
        if (!updateResponse.ok) {
          debugError('Cart update failed:', updateResponse.status, updateResponse.statusText);
          const errorText = await updateResponse.text();
          debugError('Error details:', errorText);
          return false;
        }
        
        const updatedCart = await updateResponse.json();
        
        debugLog('Cart after refresh:', {
          item_count: updatedCart.item_count,
          total_price: updatedCart.total_price,
          original_total_price: updatedCart.original_total_price,
          discount_applications: updatedCart.discount_applications,
          discount_codes: updatedCart.discount_codes
        });
        
        // Check if discounts were applied
        if (updatedCart.discount_applications && updatedCart.discount_applications.length > 0) {
          debugLog('Discounts applied:', updatedCart.discount_applications);
        } else {
          debugLog('WARNING: No discounts found after refresh');
        }
        
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('theme:cart:updated'));
        return true;
      }
      
      debugLog('No items in cart, skipping refresh');
      return false;
    } catch (error) {
      debugError('Error refreshing cart:', error);
      return false;
    }
  }
  
  // Handle checkout button click
  async function handleCheckoutClick(e) {
    debugLog('=== CHECKOUT BUTTON CLICKED ===');
    
    // Only log if customer is VIP - don't intercept
    if (!isVIPCustomer()) {
      return;
    }
    
    // Check if there are VIP-eligible items
    const hasEligibleItems = await hasVIPEligibleItems();
    if (!hasEligibleItems) {
      debugLog('No VIP-eligible items - discount will not apply');
      return;
    }
    
    debugLog('VIP customer with eligible items - proceeding to checkout');
    
    // Check current cart state
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const customerId = window.Rivo?.common?.customer?.id;
    
    debugLog('Pre-checkout state:', {
      cart_customer_id: cart.customer_id || 'NOT SET',
      logged_in_customer_id: customerId,
      customer_tags: window.Rivo?.common?.customer?.tags || [],
      note: 'Shopify will associate cart with customer at checkout'
    });
    
    if (!cart.customer_id && customerId) {
      debugLog('ℹ️  NOTE: Cart API shows no customer_id, but this is normal');
      debugLog('   Shopify associates the cart with customer when you reach checkout');
      debugLog('   Automatic discount should apply once cart is associated at checkout');
      debugLog('');
      debugLog('   If discount does NOT apply at checkout, check:');
      debugLog('   1. Discount is Active and Automatic');
      debugLog('   2. Customer tag matches exactly: "Rivo VIP Tier: Gold"');
      debugLog('   3. Products in cart match discount product conditions');
      debugLog('   4. Customer is logged in (check checkout URL)');
    } else if (cart.customer_id) {
      debugLog('✅ Cart is already associated with customer');
      debugLog('   Automatic discount should apply at checkout');
    }
    
    // Don't intercept - let checkout proceed normally
    // Shopify will handle cart association and discount application
  }
  
  // Comprehensive discount debugging
  async function verifyDiscountSetup() {
    if (!isVIPCustomer()) {
      debugLog('Customer is not VIP, skipping discount verification');
      return;
    }
    
    debugLog('=== COMPREHENSIVE DISCOUNT DEBUGGING ===');
    
    try {
      // Get customer info
      const customer = window.Rivo?.common?.customer;
      const customerTags = customer?.tags || [];
      const customerId = customer?.id;
      
      debugLog('1. CUSTOMER INFORMATION:');
      debugLog('   Customer ID:', customerId || 'NOT FOUND');
      debugLog('   Customer Tags:', customerTags);
      debugLog('   Is Logged In:', !!customerId);
      
      // Get cart info
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      debugLog('2. CART INFORMATION:');
      debugLog('   Cart Customer ID:', cart.customer_id || 'NOT SET');
      debugLog('   Item Count:', cart.item_count);
      debugLog('   Total Price:', cart.total_price / 100, 'cents = $' + (cart.total_price / 100).toFixed(2));
      debugLog('   Original Total:', cart.original_total_price / 100, 'cents = $' + (cart.original_total_price / 100).toFixed(2));
      debugLog('   Discount Applications:', cart.discount_applications || 'None');
      debugLog('   Discount Codes:', cart.discount_codes || 'None');
      
      // Detailed cart items
      if (cart.items && cart.items.length > 0) {
        debugLog('3. CART ITEMS DETAILED:');
        cart.items.forEach((item, index) => {
          const productTags = item.product_tags || [];
          const isVIPEligible = isProductVIPEligible(productTags);
          
          debugLog(`   Item ${index + 1}: ${item.product_title}`);
          debugLog(`     - Product ID: ${item.product_id}`);
          debugLog(`     - Variant ID: ${item.variant_id}`);
          debugLog(`     - Vendor: ${item.vendor || 'N/A'}`);
          debugLog(`     - Price: $${(item.price / 100).toFixed(2)}`);
          debugLog(`     - Line Price: $${(item.line_price / 100).toFixed(2)}`);
          debugLog(`     - Quantity: ${item.quantity}`);
          debugLog(`     - Product Tags:`, productTags);
          debugLog(`     - VIP Eligible: ${isVIPEligible ? 'YES' : 'NO'}`);
          
          if (!isVIPEligible) {
            debugLog(`     ⚠️  WARNING: This product is NOT VIP eligible (has club-zone tags)`);
          }
        });
      }
      
      // Check if cart is associated with customer
      debugLog('4. CART-CUSTOMER ASSOCIATION:');
      if (cart.customer_id && customerId) {
        if (cart.customer_id.toString() === customerId.toString()) {
          debugLog('   ✅ Cart is associated with customer');
        } else {
          debugLog('   ⚠️  WARNING: Cart customer ID does not match logged-in customer ID');
          debugLog('      Cart Customer ID:', cart.customer_id);
          debugLog('      Logged-in Customer ID:', customerId);
        }
      } else {
        debugLog('   ⚠️  WARNING: Cart is NOT associated with a customer');
        debugLog('      This may prevent automatic discounts from applying');
      }
      
      // Check discount eligibility
      debugLog('5. DISCOUNT ELIGIBILITY CHECK:');
      const hasEligibleItems = await hasVIPEligibleItems();
      debugLog('   Has VIP-eligible items:', hasEligibleItems ? 'YES' : 'NO');
      
      if (!hasEligibleItems) {
        debugLog('   ⚠️  WARNING: No VIP-eligible items in cart');
        debugLog('      Discount will NOT apply because all items are excluded');
      }
      
      // Instructions for checking Shopify discount
      debugLog('6. HOW TO CHECK YOUR SHOPIFY DISCOUNT CONFIGURATION:');
      debugLog('   Step 1: Go to Shopify Admin → Discounts');
      debugLog('   Step 2: Find your "Gold Member" discount');
      debugLog('   Step 3: Click on it to open');
      debugLog('   Step 4: Check these settings:');
      debugLog('');
      debugLog('   A. BASIC SETTINGS:');
      debugLog('      - Status: Must be "Active"');
      debugLog('      - Type: Should be "Automatic"');
      debugLog('');
      debugLog('   B. CUSTOMER ELIGIBILITY:');
      debugLog('      - Should be set to "Customer tags"');
      debugLog('      - Tag condition should EXACTLY match: "Rivo VIP Tier: Gold"');
      debugLog('      - Check for typos, extra spaces, or case differences');
      debugLog('      - Current customer tags:', customerTags);
      debugLog('');
      debugLog('   C. PRODUCT CONDITIONS:');
      debugLog('      - Check if products are included or excluded');
      debugLog('      - If using exclusions, make sure products with');
      debugLog('        "adidas-club-zone" or "nike-club-zone" tags are excluded');
      debugLog('      - Current cart product tags:', 
        cart.items?.flatMap(item => item.product_tags || []) || []);
      debugLog('');
      debugLog('   D. DISCOUNT VALUE:');
      debugLog('      - Should be 5% for Gold tier');
      debugLog('      - Check if it\'s percentage or fixed amount');
      debugLog('');
      
      // Test checkout URL
      debugLog('7. TESTING CHECKOUT:');
      debugLog('   To test if discount applies at checkout:');
      debugLog('   1. Click checkout button');
      debugLog('   2. On checkout page, check the order summary');
      debugLog('   3. Look for discount line item');
      debugLog('   4. If discount appears, it\'s working correctly');
      debugLog('   5. If discount doesn\'t appear, check discount configuration');
      debugLog('');
      
      debugLog('=== END DEBUGGING ===');
      
    } catch (error) {
      debugError('Error in discount verification:', error);
      debugError('Error details:', error.message, error.stack);
    }
  }
  
  // Try to ensure customer session is maintained for checkout
  async function ensureCustomerSession() {
    if (!isVIPCustomer()) return;
    
    try {
      debugLog('Ensuring customer session is maintained...');
      
      // Fetch cart to ensure customer session is active
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const customerId = window.Rivo?.common?.customer?.id;
      
      debugLog('Customer session check:', {
        cart_customer_id: cart.customer_id || 'Not set',
        logged_in_customer_id: customerId || 'Not logged in',
        note: 'Customer ID should be present for automatic discounts to work'
      });
      
      // If customer is logged in but cart doesn't have customer_id, 
      // we need to associate the cart with the customer
      if (!cart.customer_id && customerId) {
        debugLog('⚠️  Cart not associated with customer, attempting to associate...');
        
        // Method 1: Try updating cart with note/attribute that includes customer info
        // This sometimes triggers Shopify to associate the cart
        try {
          debugLog('Attempting Method 1: Cart attributes update...');
          const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: `Customer ID: ${customerId}`,
              attributes: {
                '_customer_id': customerId.toString(),
                'customer_id': customerId.toString()
              }
            })
          });
          
          if (updateResponse.ok) {
            const updatedCart = await updateResponse.json();
            debugLog('Method 1 result - Cart customer ID:', updatedCart.customer_id || 'Still not set');
            
            if (updatedCart.customer_id) {
              debugLog('✅ Successfully associated cart with customer via Method 1');
              return;
            }
          }
        } catch (error) {
          debugError('Method 1 failed:', error);
        }
        
        // Method 2: Try adding an item to trigger cart association
        // Sometimes adding/updating an item forces Shopify to associate the cart
        if (cart.items && cart.items.length > 0) {
          try {
            debugLog('Attempting Method 2: Item update to trigger association...');
            const firstItem = cart.items[0];
            const updateResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                updates: {
                  [firstItem.key]: firstItem.quantity
                },
                attributes: {
                  '_customer_id': customerId.toString()
                }
              })
            });
            
            if (updateResponse.ok) {
              const updatedCart = await updateResponse.json();
              debugLog('Method 2 result - Cart customer ID:', updatedCart.customer_id || 'Still not set');
              
              if (updatedCart.customer_id) {
                debugLog('✅ Successfully associated cart with customer via Method 2');
                return;
              }
            }
          } catch (error) {
            debugError('Method 2 failed:', error);
          }
        }
        
        // Method 3: Redirect to a page that forces cart association, then come back
        debugLog('⚠️  Methods 1 & 2 failed. Cart association may require:');
        debugLog('   1. Customer to add item while logged in');
        debugLog('   2. Or use Shopify Scripts/Plus features');
        debugLog('   3. Or ensure customer is logged in before adding to cart');
        
      } else if (cart.customer_id && customerId) {
        if (cart.customer_id.toString() === customerId.toString()) {
          debugLog('✅ Cart is properly associated with customer');
        } else {
          debugLog('⚠️  Cart customer ID mismatch');
          debugLog('   Cart ID:', cart.customer_id);
          debugLog('   Customer ID:', customerId);
        }
      } else if (!customerId) {
        debugLog('⚠️  Customer is not logged in - automatic discounts require login');
      }
    } catch (error) {
      debugError('Error ensuring customer session:', error);
    }
  }
  
  // Create a helper function to test discount application
  function createDiscountTestButton() {
    if (!isVIPCustomer()) return;
    
    // Only create in development/debug mode
    if (!DEBUG) return;
    
    // Check if button already exists
    if (document.getElementById('vip-discount-test-btn')) return;
    
    const testButton = document.createElement('button');
    testButton.id = 'vip-discount-test-btn';
    testButton.textContent = '🔍 Test VIP Discount';
    testButton.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      padding: 10px 20px;
      background: #007bff;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      z-index: 9999;
      font-size: 14px;
    `;
    
    testButton.addEventListener('click', async () => {
      debugLog('=== MANUAL DISCOUNT TEST ===');
      await verifyDiscountSetup();
      await ensureCustomerSession();
      
      // Try to go to checkout to see if discount applies
      const checkoutUrl = '/checkout';
      debugLog('Opening checkout in new tab to test discount...');
      window.open(checkoutUrl, '_blank');
    });
    
    document.body.appendChild(testButton);
  }
  
  // Attach event listeners when DOM is ready
  function initVIPCheckout() {
    // Wait a bit for page to fully load
    setTimeout(() => {
      // Verify discount setup on load
      verifyDiscountSetup();
      
      // Ensure customer session is maintained
      ensureCustomerSession();
      
      // Create test button for debugging
      createDiscountTestButton();
    }, 1000);
    
    // Monitor checkout button clicks to log what happens
    document.addEventListener('click', function(e) {
      const checkoutButton = e.target.closest('button[name="checkout"]') || 
                             e.target.closest('a[href*="/checkout"]') ||
                             e.target.closest('#cartDrawerCheckoutForm button[type="submit"]');
      
      if (checkoutButton && isVIPCustomer()) {
        debugLog('=== CHECKOUT BUTTON CLICKED ===');
        debugLog('Customer should be recognized at checkout');
        debugLog('If discount doesn\'t apply at checkout, verify:');
        debugLog('1. Discount is Active and Automatic');
        debugLog('2. Customer tag matches exactly: "Rivo VIP Tier: Gold"');
        debugLog('3. Products in cart match discount product conditions');
        debugLog('4. Customer is logged in');
        debugLog('5. Check checkout page order summary for discount');
      }
    }, true);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVIPCheckout);
  } else {
    initVIPCheckout();
  }
  
  // Also initialize after cart updates
  document.addEventListener('theme:cart:updated', initVIPCheckout);
  
  // Refresh cart when items are added to ensure automatic discounts apply
  document.addEventListener('theme:cart:added', function() {
    if (isVIPCustomer()) {
      setTimeout(refreshCartForAutomaticDiscounts, 500);
    }
  });
})();
// Redirect /collections to /collections/all
if (window.location.pathname === '/collections' || window.location.pathname === '/collections/') {
  window.location.replace('/collections/all');
}
